import { WorkbenchRuntimeError } from '../shared/errors';

export class Vector2d {
  constructor(public x: number, public y: number) {}
}

/**
 * @name getEventCoordinates
 *
 * @description Returns an object with the x and y position of a mouse or touch event
 *
 * @example
 * import { getEventCoordinates } from '@workbench/core';
 *
 * getEventCoordinates(myEvent); // { x: 48, y: 15 }
 */
export const getEventCoordinates = (event: MouseEvent | TouchEvent): Vector2d => {
  if (event instanceof MouseEvent) {
    return { x: event.clientX, y: event.clientY };
  } else if (event instanceof TouchEvent) {
    const touch = event.touches[0] || event.changedTouches[0];
    return { x: touch.clientX, y: touch.clientY };
  } else {
    throw new WorkbenchRuntimeError('invalid touch or mouse event', 'getEventCoordinates');
  }
};
